import toastEventBus from 'primevue/toasteventbus'

export function successToast(message: string) {
    toastEventBus.emit('add', {
        severity: 'success',
        detail: message,
        life: 5000,
        group: 'extended-toast-group'
    })
}

export function errorToast(errorCode: number, errors: Array<any>) {
    toastEventBus.emit('add', {
        severity: 'error',
        errorCode: errorCode,
        detail: errors,
        life: 5000,
        group: 'extended-toast-group'
    })
}